export default {
  CHECKED: "checkboxState_checked",
  MIXED: "checkboxState_mixed",
  UNCHECKED: "checkboxState_unchecked"
};
